import { $log } from './debug';
import { $http } from './http';

export namespace $api {
    export function errorHandler(response: any): never {
        if(response?.data?.data?.reason)
            throw response.data.data.reason;
        else if(response?.data?.data?.sv)
            throw response.data.data.sv;
        else if(response?.data?.message)
            throw response.data.message;

        $log('app', 'Unknown API error', response);
        throw 'Something went wrong. Try again later.'
    }

    const get_cache = new Map<string, Promise<any>>();

    export function cachedGET<Data = void>(path: string, reload?: boolean): Promise<Data> {
        if(!reload) {
            const cached = get_cache.get(path);
            if(cached)
                return cached;
        }

        const promise = $http.GET<Data>(`/api/v1/${path}`).catch(err => {
            if(get_cache.get(path) === promise)
                get_cache.delete(path);
            return errorHandler(err);
        });
        get_cache.set(path, promise);
        return promise;
    }

    export function GET<Data = void>(path: string) {
        return $http.GET<Data>(`/api/v1/${path}`).catch(errorHandler);
    }

    export function PUT<Data = void>(path: string, data?: any) {
        return $http.PUT<Data>(`/api/v1/${path}`, data).catch(errorHandler);
    }

    export function POST<Data = void>(path: string, data?: any) {
        return $http.POST<Data>(`/api/v1/${path}`, data).catch(errorHandler);
    }

    export function DELETE(path: string) {
        return $http.DELETE(`/api/v1/${path}`).catch(errorHandler);
    }
}